module.exports = __webpack_public_path__ + "media/images/fanclub/merit-chara-02@3x-5ee25d2009950334d01e0881f3de82ea.png";